import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Button,
  Stack,
} from "@mui/material";
import { styled } from "@mui/system";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import { events } from "../../../data/Data";
import { Link } from "react-router-dom";

// Util function for date formatting
const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('tr-TR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString;
  }
};

interface EventCardProps {
  event: {
    _id: string;
    content: string;
    title: string;
    createdAt: Date;
    image: string;
    date: string;  
  };
  handleClick: () => void;
}

const EventCard = styled(Card)(({ theme }) => ({
  height: "100%",
  width: "100%",
  borderRadius: "16px",
  boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.2)",
  transition: "transform 0.3s, box-shadow 0.3s",
  "&:hover": {
    transform: "scale(1.01)",
    boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.3)",
    cursor:"pointer"
  },
}));

const EventCardContent = styled(CardContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
  flexGrow: 1,
}));

const Description = styled(Typography)(({ theme }) => ({
  fontFamily: "inherit",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
}));

function slugify(title: string) {
  return title.toLowerCase().replace(/\s+/g, "-");
}

const EventCardComponent: React.FC<EventCardProps> = ({
  event,
  handleClick,
}) => (
  <EventCard>
    <Link to={`/etkinlikler/${event._id}/${slugify(event.title)}`}>
      <CardMedia
        component="img"
        height="300"
        image={event.image}
        alt={event.title}
        sx={{
          width: "100%", 
          height: "300px", 
          objectFit: "cover", 
          borderRadius: "10px" 
        }}
      />
    </Link>
    <EventCardContent>
      <Stack spacing={1} flexGrow={1}>
        <span className="B-16">{event.date}</span> {/* createdAt yerine date kullan */}
        <Link to={`/etkinlikler/${event._id}/${slugify(event.title)}`}>
          <span className="B-20-20-600">{event.title}</span>
        </Link>
        <Description
          variant="body2"
          color="textSecondary"
          dangerouslySetInnerHTML={{
            __html: Array.isArray(event.content)
              ? event.content.join(" ")
              : event.content,
          }}
        />
      </Stack>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        mt={2}
      >
        <Link to={`/etkinlikler/${event._id}/${slugify(event.title)}`}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "white",  
              color: "black",  
              textTransform: "none",  
              borderRadius: "10px",  
              fontWeight: "600",
              border: "2px solid transparent",  
              padding: "8px 20px", 
              transition: "background-color 0.3s, color 0.3s, border 0.3s", 
              "&:hover": {
                backgroundColor: "red",  
                color: "white", 
                borderColor: "#ED1C24",  
              },
            }}
          >
            Okumaya Devam Et
          </Button>
        </Link>
      </Box>
    </EventCardContent>
  </EventCard>
);

export default EventCardComponent;
